// A list of public name preferences
export const PUBLIC_NAME_LIST = [
  { label: 'username', code: 'USERNAME' },
  { label: 'full.name', code: 'FULL_NAME' },
];
